import { render, staticRenderFns } from "./nick.vue?vue&type=template&id=1f7e1db0&scoped=true&"
import script from "./nick.vue?vue&type=script&lang=js&"
export * from "./nick.vue?vue&type=script&lang=js&"
import style0 from "./nick.vue?vue&type=style&index=0&id=1f7e1db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7e1db0",
  null
  
)

export default component.exports